import React from 'react';
import { connect } from 'react-redux';
import Header from 'components/Header';
import Footer from 'components/Footer';
import ViewContainer from 'components/ViewContainer';
import './terms-template.scss';

const Component = ({ i18n, children, containerStyle }) => {
    return (
        <ViewContainer className="terms">
            <Header />
                <div className={ containerStyle }>
                    { children }
                </div>
            <Footer />
        </ViewContainer>
    );
}

export default connect(state => ({ i18n: state.i18n }))(Component);
